import dynamic from "next/dynamic";

const CustomPortalForm = dynamic(() => import("../../shadcn/_custom/custom-portal-form").then((mod) => mod.CustomPortalForm), {ssr: false});
const WebformTradeUpRequest = dynamic(() => import("../webform/webform--trade-up-request").then((mod) => mod.WebformTradeUpRequest), {ssr: false});
const WebformTechnicalSupportRequest = dynamic(() => import("../webform/webform--technical-support-request").then((mod) => mod.WebformTechnicalSupportRequest), {ssr: false});
const WebformLeadGen = dynamic(() => import("../webform/webform--lead-gen").then((mod) => mod.WebformLeadGen), {ssr: false});

export function ParagraphWebform({paragraph, ...props}) {
  if (!paragraph?.field_webform_form) return <></>

  return (
    <>
      {paragraph?.field_webform_form?.drupal_internal__id === "contact_us" &&
        <WebformLeadGen webform={paragraph.field_webform_form}
                        tradeInOptions={paragraph?.tradeInOptions ?? []}
                        productOptions={paragraph?.productOptions ?? []} />}
      {/*{paragraph?.field_webform_form?.drupal_internal__id === "technical_support_request" &&*/}
      {/*  <WebformTechnicalSupportRequest webform={paragraph.field_webform_form}/>}*/}
      {paragraph?.field_webform_form?.drupal_internal__id === "technical_support_request" && <CustomPortalForm initialTab="technical-support" className="mb-20 scroll-m-20 py-12" /> }
      {paragraph?.field_webform_form?.drupal_internal__id === "trade_up_request" &&
        <WebformTradeUpRequest webform={paragraph.field_webform_form}/>}
      {/*{paragraph?.field_webform_form?.drupal_internal__id === "lead_gen"*/}
      {/*  && <WebformLeadGen webform={paragraph.field_webform_form} tradeInOptions={paragraph?.tradeInOptions ?? []}*/}
      {/*                     productOptions={paragraph?.productOptions ?? []} />}*/}
      {paragraph?.field_webform_form?.drupal_internal__id === "lead_gen"
        && <CustomPortalForm className="mb-20 scroll-m-20 py-12" />}
    </>
  )
}
